import { Box } from '@mui/system';
import { rgba } from 'polished';
import styled from 'styled-components';

export const PageChangerContainer = styled(Box)`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 50px;
`;

export const ItemPageCounterText = styled(Box)`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 0 15px;
  color: ${(props) => props.textcolor || 'black'};
  font-family: ${(props) => props.fontfamily || 'inherit'};
`;

export const IconConteiner = styled(Box)`
  display: ${(props) => (props.hide ? 'none' : 'flex')};
  flex-direction: column;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  color: ${(props) =>
    props.disable
      ? rgba(props.iconcolor || '#000000', 0.7)
      : props.iconcolor || '000000'};
`;

export const CustomNewItemButton = styled.button`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background: transparent;
  border: none;
  padding: 0;
  cursor: pointer;
  color: ${(props) =>
    props.disable
      ? rgba(props.iconcolor || '#000000', 0.7)
      : props.iconcolor || '000000'};
`;
